export const weatherData = {
        city: {
            name: "San Francisco",
            dateTime:"Mon, 12:30 PM, Mostly Sunny",
            country: "US",

        },
        list: [
            {
                dt: 1487246400,
                main: {
                    temp: 28,
                    temp_min: 28,
                    temp_max: 28,
                    pressure: 98,
                    sea_level: 102,
                    grnd_level: 98,
                    humidity: 94,
                    temp_kf: 0.25
                },
                weather: [
                    {
                        id: 501,
                        main: "Rain",
                        description: "moderate rain",
                        icon: "10n"
                    }
                ],
                clouds: {
                    all: 92
                },
                wind: {
                    speed: 2.41,
                    deg: 189.001
                },
                rain: {
                    "3h": 3.385
                },
                sys: {
                    pod: "n"
                },
                dt_txt: "2017-11-16 12:00:00"
            },
            {
                dt: 1487257200,
                main: {
                    temp: 284.04,
                    temp_min: 283.846,
                    temp_max: 284.04,
                    pressure: 987.85,
                    sea_level: 1026.69,
                    grnd_level: 987.85,
                    humidity: 99,
                    temp_kf: 0.19
                },
                weather: [
                    {
                        id: 501,
                        main: "Rain",
                        description: "moderate rain",
                        icon: "10d"
                    }
                ],
                clouds: {
                    all: 100
                },
                wind: {
                    speed: 2.57,
                    deg: 175.001
                },
                rain: {
                    "3h": 11.005
                },
                sys: {
                    pod: "d"
                },
                dt_txt: "2017-11-15 15:00:00"
            },
            {
                dt: 1487268000,
                main: {
                    temp: 285.5,
                    temp_min: 285.373,
                    temp_max: 285.5,
                    pressure: 988.68,
                    sea_level: 1027.48,
                    grnd_level: 988.68,
                    humidity: 100,
                    temp_kf: 0.13
                },
                weather: [
                    {
                        id: 501,
                        main: "Rain",
                        description: "moderate rain",
                        icon: "10d"
                    }
                ],
                clouds: {
                    all: 100
                },
                wind: {
                    speed: 1.21,
                    deg: 207
                },
                rain: {
                    "3h": 4.325
                },
                sys: {
                    pod: "d"
                },
                dt_txt: "2017-11-14 18:00:00"
            },
            {
                dt: 1487278800,
                main: {
                    temp: 286.29,
                    temp_min: 286.228,
                    temp_max: 286.29,
                    pressure: 987.96,
                    sea_level: 1026.59,
                    grnd_level: 987.96,
                    humidity: 100,
                    temp_kf: 0.06
                },
                weather: [
                    {
                        id: 500,
                        main: "Rain",
                        description: "light rain",
                        icon: "10d"
                    }
                ],
                clouds: {
                    all: 92
                },
                wind: {
                    speed: 1.39,
                    deg: 163.502
                },
                rain: {
                    "3h": 1.565
                },
                sys: {
                    pod: "d"
                },
                dt_txt: "2017-11-13 21:00:00"
            },
        ]
    }
;




// WEBPACK FOOTER //
// ./components/Weather/weatherData.js